import { ProductCategories } from "../modules";

export const ProductCategoriesPage = () => {
  return <ProductCategories />;
};
